Vue.use(Vuex);
let store = new Vuex.Store({
  devtools: true,
  state: {
    //data management
    user: {},
    profile: {
      notify: true,
      activities: [],
    },
    services: [],
    notifications: [],
    unread: 0,
    //common refs
    sectors: [],
    studies: [],
    schedules: [],
    languages: [],
    availability: [],
    //common
    signup: false,
  },
  mutations: {
    //data
    user(state, value) {
      state.user = value;
    },
    removeUserJob(state) {
      state.user.jobs--;
    },
    removeUserApplication(state) {
      state.user.applications--;
    },
    messages(state, value) {
      state.messages = value;
    },
    notifications(state, value) {
      state.notifications = value;
    },
    unread(state, value) {
      state.unread = value;
    },
    profile(state, value) {
      state.profile = value;
    },
    terms(state, value) {
      state.terms = value;
    },
    jobs(state, value) {
      state.jobs = value;
    },
    //generic
    set: (state, data) => {
      for (let key in data) {
        state[key] = data[key];
      }
    },
    //error
    error(state, err) {
      if (err) {
        console.log('Store Error', err);
        if (err.response.status === 403) {
          alert('Ha ocurrido un error, por favor vuelve a iniciar sesión.');
          // document.location = '/';
        }
      }
    },
  },
});
